import { render, staticRenderFns } from "./customer-reservations.vue?vue&type=template&id=1c5e0fdc&scoped=true&"
import script from "./customer-reservations.vue?vue&type=script&lang=js&"
export * from "./customer-reservations.vue?vue&type=script&lang=js&"
import style0 from "./customer-reservations.vue?vue&type=style&index=0&id=1c5e0fdc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5e0fdc",
  null
  
)

export default component.exports